import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "actions/global/form-errors-handler";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
    countriesGet,
    countriesGetById,
    provincesGetById,
    provincesGetCountryById,
    citiesGetById,
    citiesGetByProvinceId,
    citiesInsert,
    citiesUpdateById,
    citiesDeleteById
} from "actions/locations/requests";

export const FETCH_COUNTRIES_SUCCESS = "FETCH_COUNTRIES_SUCCESS";
export const FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS = "FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS";
export const FETCH_CITIES_BY_PROVINCES_ID_SUCCESS = "FETCH_CITIES_BY_PROVINCES_ID_SUCCESS";

export const FETCH_COUNTRIES_BY_ID_SUCCESS = "FETCH_COUNTRIES_BY_ID_SUCCESS";
export const FETCH_PROVINCES_BY_ID_SUCCESS = "FETCH_PROVINCES_BY_ID_SUCCESS";
export const FETCH_CITIES_BY_ID_SUCCESS = "FETCH_CITIES_BY_ID_SUCCESS";

export const CLEAR_ALL_LOCATIONS = "CLEAR_ALL_LOCATIONS";

export const LOCATION_REQUEST_LOADING = "LOCATION_REQUEST_LOADING";
export const LOCATION_REQUEST_ERRORS = "LOCATION_REQUEST_ERRORS";

export const setLoading = () => ({
    type: LOCATION_REQUEST_LOADING
});

export const fetchCountries = () => dispatch => {
    dispatch(setLoading());
    countriesGet()
        .then(response => {
            dispatch({
                type: FETCH_COUNTRIES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const fetchCountryById = (countryId) => dispatch => {
    countriesGetById(countryId)
        .then(response => {
            dispatch({
                type: FETCH_COUNTRIES_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const fetchProvinces = (countryId) => dispatch => {
    dispatch(setLoading());
    provincesGetCountryById(countryId)
        .then(response => {
            dispatch({
                type: FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const fetchProvinceById = (provinceId) => dispatch => {
    provincesGetById(provinceId)
        .then(response => {
            dispatch({
                type: FETCH_PROVINCES_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const fetchCities = (provinceId) => dispatch => {
    dispatch(setLoading());
    citiesGetByProvinceId(provinceId)
        .then(response => {
            dispatch({
                type: FETCH_CITIES_BY_PROVINCES_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const fetchCitiesById = (cityId) => dispatch => {
    citiesGetById(cityId)
        .then(response => {
            dispatch({
                type: FETCH_CITIES_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const createCity = (data, callback) => dispatch => {
    dispatch(formErrorLoading());
    citiesInsert(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new city "${data.name}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateCity = (cityId, data, callback) => dispatch => {
    dispatch(formErrorLoading());
    citiesUpdateById(cityId, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`City "${data.name}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteCity = (cityId, name, callback) => dispatch => {
    dispatch(setLoading());
    citiesDeleteById(cityId)
        .then(() => {
            toast(`City "${name}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, LOCATION_REQUEST_ERRORS));
        });
};

export const clearCountries = () => dispatch => {
    dispatch({
        type: FETCH_COUNTRIES_SUCCESS,
        payload: []
    });
};

export const clearProvinces = () => dispatch => {
    dispatch({
        type: FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS,
        payload: []
    });
};

export const clearCities = () => dispatch => {
    dispatch({
        type: FETCH_CITIES_BY_PROVINCES_ID_SUCCESS,
        payload: []
    });
};

export const clearAllLocations = () => dispatch => {
    dispatch({
        type: CLEAR_ALL_LOCATIONS,
        payload: []
    });
};



// WEBPACK FOOTER //
// ./src/actions/locations/actions.js